/* eslint-disable react/display-name */
import { Fragment, useContext, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useLocation, useHistory } from "react-router-dom";
import Nav from "../Nav/Nav";
import styles from "./Confirmation.module.scss";
import { arrayOf } from "../../../utils/array";
import { ConsultantPaths as Paths } from "../../../constants/paths";
import Button, { LIGHT_ALT } from "../../common/Button/Button";
import { JobsterContext } from "../../../context/JobsterContext";

const Confirmation = () => {
  const { isJobsterReady } = useContext(JobsterContext);
  const location = useLocation();
  const history = useHistory();
  const searchParams = new URLSearchParams(location.search);
  const returnUrl = searchParams.get("returnUrl");

  useEffect(() => {
    if (isJobsterReady && window.jobster) {
      try {
        window.jobster.push(function () {
          // eslint-disable-next-line no-undef
          window.jobster.conversion("f5561913-1022-4863-97c3-65baf3385f94", "customer");
        });
      } catch (error) {
        console.log("Error running conversion script:", error);
      }
    }
  }, [isJobsterReady]);

  const handleLogin = () => {
    const loginUrl = returnUrl || Paths.dashboard();
    history.push(loginUrl);
  };

  return (
    <Fragment>
      <Nav showBack={false} />
      <div className="container text-white">
        <div className="row">
          <div className="col-md-6">
            <div className={`${styles.heading} font-weight-700`}>
              <FormattedMessage id="confirmation.heading" />
            </div>
            {arrayOf(2).map((_, i) => (
              // eslint-disable-next-line react/jsx-key
              <div className="my-4 d-flex">
                <div className="ml-2">
                  <FormattedMessage id={`confirmation.body${i + 1}`} />
                </div>
              </div>
            ))}
            <div className="mt-4 d-flex">
              <div className="ml-2">
                <Button 
                  variant={LIGHT_ALT} 
                  className="space-letters"
                  onClick={handleLogin}
                >
                  <FormattedMessage 
                    id={returnUrl ? "confirmation.loginToJoin" : "confirmation.login"} 
                    defaultMessage={returnUrl ? "Login to Join" : "Login"}
                  />
                </Button>
              </div>
            </div>

            <div className="mt-4 d-flex">
              <div className="ml-2">
                <FormattedMessage id={"confirmation.body3"} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Confirmation;
